<template>
  <div>
    <v-divider class="my-4"></v-divider>
    <v-col cols="12"
           xl="8"
           lg="12"
           class="px-0">
      <v-row class="mx-n2"
             v-if="isCompanyLoaded">
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>partner</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.partnerDisplayName}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper"
               @mouseover="isTenantIdCopyBtnVisible = true"
               @mouseleave="isTenantIdCopyBtnVisible = false">
            <p class="label caption">
              <LocalizedLabel>tenantId</LocalizedLabel>
              <v-btn icon
                     x-small
                     class="pa-0 ma-0 copyButton"
                     v-if="isTenantIdCopyBtnVisible && companyDetails.id"
                     @click="copy(mappedCompanyDetails.id)">
                <v-icon color="subtitle">mdi-content-copy</v-icon>
              </v-btn>
            </p>
            <p class="value caption oneliner subtitle--text">
              {{mappedCompanyDetails.id}}
            </p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isSevenPartner">
          <div class="companyDetailsWrapper"
               @mouseover="isSevenCompanyIdCopyBtnVisible = true"
               @mouseleave="isSevenCompanyIdCopyBtnVisible = false">
            <p class="label caption">
              <LocalizedLabel>sevenCompanyId</LocalizedLabel>
              <v-btn icon
                     x-small
                     class="pa-0 ma-0 copyButton"
                     v-if="isSevenCompanyIdCopyBtnVisible"
                     @click="copy(mappedCompanyDetails.sevenCompanyId)">
                <v-icon color="subtitle">mdi-content-copy</v-icon>
              </v-btn>
            </p>
            <p class="value caption oneliner subtitle--text">
              {{mappedCompanyDetails.sevenCompanyId}}
            </p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isSevenPartner">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>walletDc</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.sevenWalletDC}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isIsoftbetPartner">
          <div class="companyDetailsWrapper"
               @mouseover="isIsoftbetLicenseeIdCopyBtnVisible = true"
               @mouseleave="isIsoftbetLicenseeIdCopyBtnVisible = false">
            <p class="label caption">
              <LocalizedLabel>licenseeId</LocalizedLabel>
              <v-btn icon
                     x-small
                     class="pa-0 ma-0 copyButton"
                     v-if="isIsoftbetLicenseeIdCopyBtnVisible"
                     @click="copy(mappedCompanyDetails.isoftbetLicenseeId)">
                <v-icon color="subtitle">mdi-content-copy</v-icon>
              </v-btn>
            </p>
            <p class="value caption oneliner subtitle--text">
              {{mappedCompanyDetails.isoftbetLicenseeId}}
            </p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isIsoftbetPartner">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>walletUrl</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.isoftbetWalletUrl}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isDualSoftPartner">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>walletCode</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.dualsoftWalletCode}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isSingularPartner">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>brand</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.singularBrand}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2"
               v-if="isDualSoftPartner">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>walletUrl</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.dualsoftWalletUrl}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>currencies</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.currencies}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper">
            <p class="label caption">DC</p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.dc}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>markets</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.markets}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper">
            <p class="label caption">
              <LocalizedLabel>jackpot</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.jackpotActive}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper"
               :class="isJackpotInfoDisabled">
            <p class="label caption">
              <LocalizedLabel>jackpotContribution</LocalizedLabel> %
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.jackpotContribution}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="4"
               class="pa-2">
          <div class="companyDetailsWrapper"
               :class="isJackpotInfoDisabled">
            <p class="label caption">
              <LocalizedLabel>jackpotProbability</LocalizedLabel>
            </p>
            <p class="value caption subtitle--text">
              {{mappedCompanyDetails.jackpotProbability}}</p>
          </div>
        </v-col>
        <v-col cols="12"
               class="pa-2 pt-4"
               v-if="currenciesList.length">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12"
               class="pa-2"
               v-for="(currency, index) in currenciesList"
               :key="currency">
          <v-divider v-if="index"
                     class="mb-4"></v-divider>
          <p class="currencyTitle subtitle-2">{{currency}}</p>
          <div v-for="group in limitGroups"
               :key="group.valueKey">
            <p class="label caption mb-1">
              <span v-html="translations[group.titleKey]"></span>
              <v-tooltip transition="slide-x-transition"
                         right
                         max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon dark
                          small
                          color="disabled"
                          class="pl-2 mt-n1"
                          v-bind="attrs"
                          v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span v-html="translations[group.tooltipKey]"></span>
              </v-tooltip>
            </p>
            <v-row class="mx-n2 mb-2">
              <v-col cols="12"
                     sm="6"
                     md="4"
                     class="pa-2"
                     v-for="amount in amountsList"
                     :key="amount.label">
                <div class="companyDetailsWrapper">
                  <p class="label caption">
                    <LocalizedLabel>{{amount.label}}</LocalizedLabel>
                  </p>
                  <p class="value caption subtitle--text"
                     v-html="formatCurrency(getCurrencyLimitValue(currency, amount[group.valueKey]))"></p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  has,
  isEmpty,
  isNil,
  join,
  map,
} from 'lodash';
import { mapGameTypesToCurrencyLimits, roundDecimals } from '@/utility';

export default {
  name: 'companyDetails',
  data() {
    return {
      companyDetails: {},
      isTenantIdCopyBtnVisible: false,
      isExternalIdCopyBtnVisible: false,
      isSevenCompanyIdCopyBtnVisible: false,
      isIsoftbetLicenseeIdCopyBtnVisible: false,
      amountsList: [
        { label: 'minStake', perLineValue: 'minBetPerLineAmount', totalValue: 'minBetAmount' },
        { label: 'maxStake', perLineValue: 'maxBetPerLineAmount', totalValue: 'maxBetAmount' },
        { label: 'maxWinLimit', perLineValue: 'maxWinPerLineAmount', totalValue: 'maxWinAmount' },
      ],
      limitGroups: [
        {
          titleKey: 'perLineLimits',
          tooltipKey: 'tenantPerLineLimitsTooltip',
          valueKey: 'perLineValue',
        },
        {
          titleKey: 'totalLimits',
          tooltipKey: 'tenantTotalLimitsTooltip',
          valueKey: 'totalValue',
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      'loadData',
    ]),
    copy(item) {
      navigator.clipboard.writeText(item);
    },
    getJackpotStatus(value) {
      return has(value, 'active') ? value.active : true;
    },
    formatCurrency(value) {
      if (isNil(value)) {
        return '&infin;';
      }
      return roundDecimals(value);
    },
    getCurrencyLimitValue(currency, inputType) {
      return this.currenciesLimits[currency]?.[inputType];
    },
  },
  computed: {
    ...mapGetters([
      'partners',
      'translations',
    ]),
    isCompanyLoaded() {
      return !isEmpty(this.companyDetails);
    },
    currenciesLimits() {
      return mapGameTypesToCurrencyLimits(this.companyDetails.settings?.gameTypes);
    },
    currenciesList() {
      return this.companyDetails.currencies || Object.keys(this.currenciesLimits);
    },
    mappedCompanyDetails() {
      if (this.companyDetails) {
        const list = map([this.companyDetails], (company) => ({
          ...company,
          partnerDisplayName: company.partnerDisplayName || '-',
          externalId: company.externalId || '-',
          currencies: join(company.currencies, ', '),
          jackpotActive: this.getJackpotStatus(company.settings.jackpot)
            ? this.translations.enabled : this.translations.disabled,
          jackpotContribution: company.settings.jackpot.contribution || '-',
          jackpotProbability: company.settings.jackpot.probabilityPct
            ? parseFloat(1 / company.settings.jackpot.probabilityPct).toFixed() : '-',
          id: company.id || '-',
          sevenWalletDC: company.meta?.sevenWalletDC || '-',
          sevenCompanyId: company.meta?.sevenCompanyId || '-',
          isoftbetLicenseeId: company.meta?.isoftbetLicenseeId || '-',
          isoftbetWalletUrl: company.meta?.isoftbetWalletUrl || '-',
          dualsoftWalletCode: company.meta?.dualsoftWalletCode ? join(company.meta.dualsoftWalletCode, ', ') : '-',
          dualsoftWalletUrl: company.meta?.dualsoftWalletUrl || '-',
          markets: join(company.settings.markets, ', ') || '-',
          singularBrand: company.meta?.brand || '-',
          dc: company.dc || '-',
        }));
        return list[0];
      }
      return {};
    },
    isJackpotInfoDisabled() {
      return !this.getJackpotStatus(this.companyDetails.settings.jackpot) ? 'disabledInfo' : '';
    },
    isSevenPartner() {
      const sevenPartner = this.partners.find((partner) => partner.displayName === 'Seven');

      return this.companyDetails.partnerId === sevenPartner?.id;
    },
    isDualSoftPartner() {
      const dualSoftPartner = this.partners.find((partner) => partner.displayName === 'DualSoft');

      return this.companyDetails.partnerId === dualSoftPartner?.id;
    },
    isIsoftbetPartner() {
      const isoftbetPartner = this.partners.find((partner) => partner.displayName === 'iSoftBet');

      return this.companyDetails.partnerId === isoftbetPartner?.id;
    },
    isSingularPartner() {
      const singularPartner = this.partners.find((partner) => partner.displayName === 'Singular');

      return this.companyDetails.partnerId === singularPartner?.id;
    },
  },
  async created() {
    const response = await this.loadData({
      path: `tenants/${this.$route.query.companyId}`,
    });
    if (response) {
      this.companyDetails = response.data;
    }
  },
};
</script>

<style lang="scss" scoped>
.companyDetailsWrapper {
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 4px;
  padding: 3px;
  .label,
  .value {
    margin: 0 15px;
  }
  .oneliner {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .copyButton {
    float: right;
  }
}
.disabledInfo p {
  opacity: 0.5;
}
.currencyTitle {
  margin-bottom: 12px;
}
</style>
